/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmployeeLeaveSettingsImportData
 */
export interface EmployeeLeaveSettingsImportData {
    /**
     * 
     * @type {number}
     * @memberof EmployeeLeaveSettingsImportData
     */
    uploadId: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeLeaveSettingsImportData
     */
    employeeCount: number;
}

/**
 * Check if a given object implements the EmployeeLeaveSettingsImportData interface.
 */
export function instanceOfEmployeeLeaveSettingsImportData(value: object): value is EmployeeLeaveSettingsImportData {
    if (!('uploadId' in value) || value['uploadId'] === undefined) return false;
    if (!('employeeCount' in value) || value['employeeCount'] === undefined) return false;
    return true;
}

export function EmployeeLeaveSettingsImportDataFromJSON(json: any): EmployeeLeaveSettingsImportData {
    return EmployeeLeaveSettingsImportDataFromJSONTyped(json, false);
}

export function EmployeeLeaveSettingsImportDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeLeaveSettingsImportData {
    if (json == null) {
        return json;
    }
    return {
        
        'uploadId': json['uploadId'],
        'employeeCount': json['employeeCount'],
    };
}

  export function EmployeeLeaveSettingsImportDataToJSON(json: any): EmployeeLeaveSettingsImportData {
      return EmployeeLeaveSettingsImportDataToJSONTyped(json, false);
  }

  export function EmployeeLeaveSettingsImportDataToJSONTyped(value?: EmployeeLeaveSettingsImportData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uploadId': value['uploadId'],
        'employeeCount': value['employeeCount'],
    };
}

